import {getInternalWebsiteBaseUrl} from '../../../web-common/scripts/utils/whitelabelUtils';
import {browserHistory} from 'react-router';

function backToAgenda({event, isWidget, serverRendered}) {
    const path = isWidget ? 'agenda?widget=true' : 'agenda';
    const url = getInternalWebsiteBaseUrl(event, path);
    serverRendered
        ? browserHistory.push(url)
        : browserHistory.goBack();
}

export default backToAgenda;
